import React, { useEffect, useState, useLayoutEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Container, Row, Col, Table } from "react-bootstrap";
import "./planchang.css";
import { useLocation } from 'react-router-dom';

function PlanChange(props) {
  const [data, setData] = useState("equity");
  const [plan, setPlan] = useState('A');
  const [dmore, setMore] = useState("");
  const [dless, setLess] = useState("d-none");
  const [tabName, setTabName] = useState("equity");
  const location = useLocation();

  useLayoutEffect(() => {
    if (props.plan != '') {
      setPlan(props.plan);
    }
    else if (location.state != null && location.state.plan != '') {
      setPlan(location.state.plan);
    }

  }, [props]);
  const clickHandler = (e) => {
    if (e.target.id == "more") {
      setMore("d-none")
      setLess("")
    }
    else if (e.target.id == "less") {
      setLess("d-none")
      setMore("")
    }
    else {
      setLess("d-none")
      setMore("")
    }
    //setData(e.currentTarget.dataset.id);
  };

  return (
    <>
      <section className="planchange">
        <Container className="planchanges">
          <Row>
            <Col>
              <div className="pricingpageplanfull_section">
                {/*<h2>Our Pricing</h2>
               <Tabs
                defaultActiveKey="planA"
                id="justify-tab-example"
                className="mb-3"
                justify
              >
                <Tab eventKey="planA" title="Plan A">
                  Plan A
                </Tab>
                <Tab eventKey="planB" title="Plan B">
                  Plan B
                </Tab>
              </Tabs> */}
                {(plan == "A") ? <><Tabs
                  defaultActiveKey="planA"
                  id="justify-tab-example"
                  className="mb-3"
                  onSelect={(index, label) => { setLess("d-none"); setMore("") }}
                >
                  <Tab eventKey="planA" title="Plan A">
                    <div className="inner-tab-section">
                      <Tabs
                        defaultActiveKey="equity"
                        id="justify-tab-example1"
                        className="mb-3"
                        onSelect={(index, label) => { setLess("d-none"); setMore("") }}
                      >
                        <Tab eventKey="equity" title="Equity">
                          <Table bordered>
                            <tbody>
                              <tr>
                                <td></td>
                                <td>Equity delivery </td>
                                <td>Equity intraday</td>
                                <td>Equity futures</td>
                                <td>Equity options</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Brokerage</strong>
                                </td>
                                <td>Zero Brokerage</td>
                                <td>
                                  2.5% or Rs. 20/executed order whichever is lower
                                </td>
                                <td>
                                  2.5% or Rs. 20/executed order whichever is lower
                                </td>
                                <td>Flat Rs. 20 per executed order</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>STT/CTT</strong>
                                </td>
                                <td>0.1% on buy & sell</td>
                                <td>0.025% on the sell side</td>
                                <td>0.02% on sell side</td>
                                <td>0.1% on sell side (on premium)</td>
                              </tr>
                              <tr>
                                <td rowSpan={2}>
                                  <strong>Transaction charges</strong>
                                </td>
                                <td>NSE: 0.00297%</td>
                                <td>NSE: 0.00297%</td>
                                <td >NSE: 0.00173%</td>
                                {/* <td rowSpan={2}>NSE: 0.00188%</td> */}
                                <td>NSE: 0.03503% (on premium)</td>
                              </tr>
                              <tr>
                                <td>BSE: 0.00375%</td>
                                <td>BSE: 0.00375%</td>
                                <td>BSE: NIL</td>

                                {/* <td>BSE: 0.0375% (on premium)</td> */}
                                <td>BSE: 0.0325% (on the premium of Sensex & Bankex options)<br></br>0.005% (Sensex 50 options & Stock Options)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>GST</strong>
                                </td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>SEBI charges</strong>
                                </td>
                                <td>₹10 / crore</td>
                                <td>₹10 / crore</td>
                                <td>₹10 / crore</td>
                                <td>₹10 / crore</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Stamp charges</strong>
                                </td>
                                <td>0.015% or ₹1500 / crore on buy side</td>
                                <td>0.003% or ₹300 / crore on buy side</td>
                                <td>0.002% or ₹200 / crore on buy side</td>
                                <td>0.003% or ₹300 / crore on buy side</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong></strong>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            </tbody>
                          </Table>
                        </Tab>
                        <Tab eventKey="currency" title="Currency">
                          <Table bordered>
                            <tbody>
                              <tr>
                                <td></td>
                                <td>Currency futures</td>
                                <td>Currency options</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Brokerage</strong>
                                </td>
                                <td>
                                  0.03% or Rs. 20/executed order whichever is
                                  lower
                                </td>
                                <td>
                                  0.03% or Rs. 20/executed order whichever is
                                  lower
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>STT/CTT</strong>
                                </td>
                                <td>No STT</td>
                                <td>No STT</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Transaction charges</strong>
                                </td>
                                <td>NSE – Exchange txn charge: 0.00035%</td>
                                <td>NSE – Exchange txn charge: 0.0311%(on premium)</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>BSE – Exchange txn charge: 0.00045%</td>
                                <td>BSE – Exchange txn charge: 0.001%(on premium)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>GST</strong>
                                </td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>SEBI charges</strong>
                                </td>
                                <td>₹10 / crore </td>
                                <td>₹10 / crore</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Stamp charges</strong>
                                </td>
                                <td>0.0001% or ₹10 / crore on buy side</td>
                                <td>0.0001% or ₹10 / crore on buy side</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            </tbody>
                          </Table>
                        </Tab>
                        <Tab eventKey="commodity" title="Commodity">
                          <Table bordered>
                            <tbody>
                              <tr>
                                <td></td>
                                <td>Commodity futures</td>
                                <td>Commodity options</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Brokerage</strong>
                                </td>
                                <td>
                                  0.03% or Rs. 20/executed order whichever is
                                  lower
                                </td>
                                <td>
                                  0.03% or Rs. 20/executed order whichever is
                                  lower
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>STT/CTT</strong>
                                </td>
                                <td>0.01% on sell side (Non-Agri)</td>
                                <td>0.05% on sell side</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Transaction charges</strong>
                                </td>
                                <td>Group A – Exchange txn charge: 0.0021%</td>
                                <td>Exchange txn charge: 0.0418%</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>Group B – Exchange txn charge:</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>CASTORSEED – 0.0005%</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>KAPAS – 0.0026%</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>PEPPER – 0.00005%</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>RBDPMOLEIN – 0.001%</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>GST</strong>
                                </td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>SEBI charges</strong>
                                </td>
                                <td>Agri – ₹1 / crore</td>
                                <td>₹10 / crore</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>Non-agri – ₹10 / crore</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Stamp charges</strong>
                                </td>
                                <td>0.002% or ₹200 / crore on buy side</td>
                                <td>0.003% or ₹300 / crore on buy side</td>
                              </tr>
                            </tbody>
                          </Table>
                        </Tab>
                      </Tabs>
                    </div>
                  </Tab>
                  <Tab eventKey="planB" title="Plan B">
                    <div className="inner-tab-section">
                      <Tabs
                        defaultActiveKey="equity"
                        id="justify-tab-example1"
                        className="mb-3"
                        onSelect={(index, label) => { setLess("d-none"); setMore("") }}
                      >
                        <Tab eventKey="equity" title="Equity">
                          <Table bordered>
                            <tbody>
                              <tr>
                                <td></td>
                                <td>Equity delivery</td>
                                <td>Equity intraday</td>
                                <td>Equity futures</td>
                                <td>Equity options</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Brokerage</strong>
                                </td>
                                <td>
                                  2.5 % or Rs. 10 per executed order whichever is
                                  lower
                                </td>
                                <td>
                                  2.5% or Rs. 10 per executed order whichever is
                                  lower
                                </td>
                                <td>
                                  2.5% or Rs. 10 per executed order whichever is
                                  lower
                                </td>
                                <td>Flat Rs. 10 per executed order</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>STT/CTT</strong>
                                </td>
                                <td>0.1% on buy & sell</td>
                                <td>0.025% on the sell side</td>
                                <td>0.02% on sell side</td>
                                <td>0.1% on sell side (on premium)</td>
                              </tr>
                              <tr>
                                <td rowSpan={2}>
                                  <strong>Transaction charges</strong>
                                </td>
                                <td>NSE: 0.00297%</td>
                                <td>NSE: 0.00297%</td>
                                <td>NSE: 0.00173%</td>
                                <td>NSE: 0.03503% (on premium)</td>
                              </tr>
                              <tr>
                                <td>BSE: 0.00375%</td>
                                <td>BSE: 0.00375%</td>
                                <td>BSE: NIL</td>

                                <td>0.0325% (on the premium of Sensex & Bankex options)<br></br>0.005% (Sensex 50 options & Stock Options)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>GST</strong>
                                </td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>SEBI charges</strong>
                                </td>
                                <td>₹10 / crore</td>
                                <td>₹10 / crore</td>
                                <td>₹10 / crore</td>
                                <td>₹10 / crore</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Stamp charges</strong>
                                </td>
                                <td>0.015% or ₹1500 / crore on buy side</td>
                                <td>0.003% or ₹300 / crore on buy side</td>
                                <td>0.002% or ₹200 / crore on buy side</td>
                                <td>0.003% or ₹300 / crore on buy side</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong></strong>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            </tbody>
                          </Table>
                        </Tab>
                        <Tab eventKey="currency" title="Currency">
                          <Table bordered>
                            <tbody>
                              <tr>
                                <td></td>
                                <td>Currency futures</td>
                                <td>Currency options</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Brokerage</strong>
                                </td>
                                <td>
                                  0.03% or Rs. 10/executed order whichever is
                                  lower
                                </td>
                                <td>
                                  0.03% or Rs. 10/executed order whichever is
                                  lower
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>STT/CTT</strong>
                                </td>
                                <td>No STT</td>
                                <td>No STT</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Transaction charges</strong>
                                </td>
                                <td>NSE – Exchange txn charge: 0.00035%</td>
                                <td>NSE – Exchange txn charge: 0.0311%(on premium)</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>BSE – Exchange txn charge: 0.00045%</td>
                                <td>BSE – Exchange txn charge: 0.001%(on premium)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>GST</strong>
                                </td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>SEBI charges</strong>
                                </td>
                                <td>₹10 / crore</td>
                                <td>₹10 / crore</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Stamp charges</strong>
                                </td>
                                <td>0.0001% or ₹10 / crore on buy side</td>
                                <td>0.0001% or ₹10 / crore on buy side</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            </tbody>
                          </Table>
                        </Tab>
                        <Tab eventKey="commodity" title="Commodity">
                          <Table bordered>
                            <tbody>
                              <tr>
                                <td></td>
                                <td>Commodity  futures</td>
                                <td>Commodity  options</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Brokerage</strong>
                                </td>
                                <td>
                                  0.03% or Rs. 10/executed order whichever is
                                  lower
                                </td>
                                <td>
                                  0.03% or Rs. 10/executed order whichever is
                                  lower
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>STT/CTT</strong>
                                </td>
                                <td>0.01% on sell side (Non-Agri)</td>
                                <td>0.05% on sell side</td>
                              </tr>
                              <tr>
                                <td rowSpan={6}>
                                  <strong>Transaction charges</strong>
                                </td>
                                <td>Group A – Exchange txn charge: 0.0021%</td>
                                <td>Exchange txn charge: 0.0418%</td>
                              </tr>
                              <tr>
                                <td>Group B – Exchange txn charge:</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>CASTORSEED – 0.0005%</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>KAPAS – 0.0026%</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>PEPPER – 0.00005%</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>RBDPMOLEIN – 0.001%</td>
                                <td></td>
                              </tr>

                              <tr>
                                <td>
                                  <strong>GST</strong>
                                </td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>SEBI charges</strong>
                                </td>
                                <td>Agri – ₹1 / crore</td>
                                <td>₹10 / crore</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>Non-agri – ₹10 / crore</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Stamp charges</strong>
                                </td>
                                <td>0.002% or ₹200 / crore on buy side</td>
                                <td>0.003% or ₹300 / crore on buy side</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            </tbody>
                          </Table>
                        </Tab>
                      </Tabs>
                    </div>
                  </Tab>
                </Tabs></> : <Tabs
                  defaultActiveKey="planB"
                  id="justify-tab-example"
                  className="mb-3"
                  onSelect={(index, label) => { setLess("d-none"); setMore("") }}
                >
                  <Tab eventKey="planA" title="Plan A">
                    <div className="inner-tab-section">
                      <Tabs
                        defaultActiveKey="equity"
                        id="justify-tab-example1"
                        className="mb-3"
                        onSelect={(index, label) => { setLess("d-none"); setMore("") }}
                      >
                        <Tab eventKey="equity" title="Equity">
                          <Table bordered>
                            <tbody>
                              <tr>
                                <td></td>
                                <td>Equity delivery </td>
                                <td>Equity intraday</td>
                                <td>Equity futures</td>
                                <td>Equity options</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Brokerage</strong>
                                </td>
                                <td>Zero Brokerage</td>
                                <td>
                                  2.5% or Rs. 20/executed order whichever is lower
                                </td>
                                <td>
                                  2.5% or Rs. 20/executed order whichever is lower
                                </td>
                                <td>Flat Rs. 20 per executed order</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>STT/CTT</strong>
                                </td>
                                <td>0.1% on buy & sell</td>
                                <td>0.025% on the sell side</td>
                                <td>0.02% on the sell side</td>
                                <td>0.1% on sell side (on premium)</td>
                              </tr>
                              <tr>
                                <td rowSpan={2}>
                                  <strong>Transaction charges</strong>
                                </td>
                                <td>NSE: 0.00297%</td>
                                <td>NSE: 0.00297%</td>
                                <td>NSE: 0.00173%</td>
                                <td>NSE: 0.03503% (on premium)</td>
                              </tr>
                              <tr>
                                <td>BSE: 0.00375%</td>
                                <td>BSE: 0.00375%</td>
                                <td>BSE: NIL</td>

                                <td>BSE: 0.0325% (on the premium of Sensex & Bankex options)<br></br>0.005% (Sensex 50 options & Stock Options)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>GST</strong>
                                </td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>SEBI charges</strong>
                                </td>
                                <td>₹10 / crore</td>
                                <td>₹10 / crore</td>
                                <td>₹10 / crore</td>
                                <td>₹10 / crore</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Stamp charges</strong>
                                </td>
                                <td>0.015% or ₹1500 / crore on buy side</td>
                                <td>0.003% or ₹300 / crore on buy side</td>
                                <td>0.002% or ₹200 / crore on buy side</td>
                                <td>0.003% or ₹300 / crore on buy side</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong></strong>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            </tbody>
                          </Table>
                        </Tab>
                        <Tab eventKey="currency" title="Currency">
                          <Table bordered>
                            <tbody>
                              <tr>
                                <td></td>
                                <td>Currency futures</td>
                                <td>Currency options</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Brokerage</strong>
                                </td>
                                <td>
                                  0.03% or Rs. 20/executed order whichever is
                                  lower
                                </td>
                                <td>
                                  0.03% or Rs. 20/executed order whichever is
                                  lower
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>STT/CTT</strong>
                                </td>
                                <td>No STT</td>
                                <td>No STT</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Transaction charges</strong>
                                </td>
                                <td>NSE – Exchange txn charge: 0.00035%</td>
                                <td>NSE – Exchange txn charge: 0.0311%(on premium)</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>BSE – Exchange txn charge: 0.00045%</td>
                                <td>BSE – Exchange txn charge: 0.001%(on premium)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>GST</strong>
                                </td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>SEBI charges</strong>
                                </td>
                                <td>₹10 / crore </td>
                                <td>₹10 / crore</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Stamp charges</strong>
                                </td>
                                <td>0.0001% or ₹10 / crore on buy side</td>
                                <td>0.0001% or ₹10 / crore on buy side</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            </tbody>
                          </Table>
                        </Tab>
                        <Tab eventKey="commodity" title="Commodity">
                          <Table bordered>
                            <tbody>
                              <tr>
                                <td></td>
                                <td>Commodity futures</td>
                                <td>Commodity options</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Brokerage</strong>
                                </td>
                                <td>
                                  0.03% or Rs. 20/executed order whichever is
                                  lower
                                </td>
                                <td>
                                  0.03% or Rs. 20/executed order whichever is
                                  lower
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>STT/CTT</strong>
                                </td>
                                <td>0.01% on sell side (Non-Agri)</td>
                                <td>0.05% on sell side</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Transaction charges</strong>
                                </td>
                                <td>Group A – Exchange txn charge: 0.0021%</td>
                                <td>Exchange txn charge: 0.0418%</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>Group B – Exchange txn charge:</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>CASTORSEED – 0.0005%</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>KAPAS – 0.0026%</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>PEPPER – 0.00005%</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>RBDPMOLEIN – 0.001%</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>GST</strong>
                                </td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>SEBI charges</strong>
                                </td>
                                <td>Agri – ₹1 / crore</td>
                                <td>₹10 / crore</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>Non-agri – ₹10 / crore</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Stamp charges</strong>
                                </td>
                                <td>0.002% or ₹200 / crore on buy side</td>
                                <td>0.003% or ₹300 / crore on buy side</td>
                              </tr>
                            </tbody>
                          </Table>
                        </Tab>
                      </Tabs>
                    </div>
                  </Tab>
                  <Tab eventKey="planB" title="Plan B">
                    <div className="inner-tab-section">
                      <Tabs
                        defaultActiveKey="equity"
                        id="justify-tab-example1"
                        className="mb-3"
                        onSelect={(index, label) => { setLess("d-none"); setMore("") }}
                      >
                        <Tab eventKey="equity" title="Equity">
                          <Table bordered>
                            <tbody>
                              <tr>
                                <td></td>
                                <td>Equity delivery</td>
                                <td>Equity intraday</td>
                                <td>Equity futures</td>
                                <td>Equity options</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Brokerage</strong>
                                </td>
                                <td>
                                  2.5 % or Rs. 10 per executed order whichever is
                                  lower
                                </td>
                                <td>
                                  2.5% or Rs. 10 per executed order whichever is
                                  lower
                                </td>
                                <td>
                                  2.5% or Rs. 10 per executed order whichever is
                                  lower
                                </td>
                                <td>Flat Rs. 10 per executed order</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>STT/CTT</strong>
                                </td>
                                <td>0.1% on buy & sell</td>
                                <td>0.025% on the sell side</td>
                                <td>0.02% on sell side</td>
                                <td>0.1% on sell side (on premium)</td>
                              </tr>
                              <tr>
                                <td rowSpan={2}>
                                  <strong>Transaction charges</strong>
                                </td>
                                <td>NSE: 0.00297%</td>
                                <td>NSE: 0.00297%</td>
                                <td>NSE: 0.00173%</td>
                                <td>NSE: 0.03503% (on premium)</td>
                              </tr>
                              <tr>
                                <td>BSE: 0.00375%</td>
                                <td>BSE: 0.00375%</td>
                                <td>BSE: NIL</td>

                                <td>BSE: 0.0325% (on the premium of Sensex & Bankex options)<br></br>0.005% (Sensex 50 options & Stock Options)</td>
                                {/* <td>BSE: 0.0375% (on premium)</td> */}
                              </tr>
                              <tr>
                                <td>
                                  <strong>GST</strong>
                                </td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>SEBI charges</strong>
                                </td>
                                <td>₹10 / crore</td>
                                <td>₹10 / crore</td>
                                <td>₹10 / crore</td>
                                <td>₹10 / crore</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Stamp charges</strong>
                                </td>
                                <td>0.015% or ₹1500 / crore on buy side</td>
                                <td>0.003% or ₹300 / crore on buy side</td>
                                <td>0.002% or ₹200 / crore on buy side</td>
                                <td>0.003% or ₹300 / crore on buy side</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong></strong>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            </tbody>
                          </Table>
                        </Tab>
                        <Tab eventKey="currency" title="Currency">
                          <Table bordered>
                            <tbody>
                              <tr>
                                <td></td>
                                <td>Currency futures</td>
                                <td>Currency options</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Brokerage</strong>
                                </td>
                                <td>
                                  0.03% or Rs. 10/executed order whichever is
                                  lower
                                </td>
                                <td>
                                  0.03% or Rs. 10/executed order whichever is
                                  lower
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>STT/CTT</strong>
                                </td>
                                <td>No STT</td>
                                <td>No STT</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Transaction charges</strong>
                                </td>
                                <td>NSE – Exchange txn charge: 0.00035%</td>
                                <td>NSE – Exchange txn charge: 0.0311%(on premium)</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>BSE – Exchange txn charge: 0.00045%</td>
                                <td>BSE – Exchange txn charge: 0.001%(on premium)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>GST</strong>
                                </td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>SEBI charges</strong>
                                </td>
                                <td>₹10 / crore</td>
                                <td>₹10 / crore</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Stamp charges</strong>
                                </td>
                                <td>0.0001% or ₹10 / crore on buy side</td>
                                <td>0.0001% or ₹10 / crore on buy side</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            </tbody>
                          </Table>
                        </Tab>
                        <Tab eventKey="commodity" title="Commodity">
                          <Table bordered>
                            <tbody>
                              <tr>
                                <td></td>
                                <td>Commodity futures</td>
                                <td>Commodity options</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Brokerage</strong>
                                </td>
                                <td>
                                  0.03% or Rs. 10/executed order whichever is
                                  lower
                                </td>
                                <td>
                                  0.03% or Rs. 10/executed order whichever is
                                  lower
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>STT/CTT</strong>
                                </td>
                                <td>0.01% on sell side (Non-Agri)</td>
                                <td>0.05% on sell side</td>
                              </tr>
                              <tr>
                                <td rowSpan={6}>
                                  <strong>Transaction charges</strong>
                                </td>
                                <td>Group A – Exchange txn charge: 0.0021%</td>
                                <td>Exchange txn charge: 0.0418%</td>
                              </tr>
                              <tr>
                                <td>Group B – Exchange txn charge:</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>CASTORSEED – 0.0005%</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>KAPAS – 0.0026%</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>PEPPER – 0.00005%</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>RBDPMOLEIN – 0.001%</td>
                                <td></td>
                              </tr>

                              <tr>
                                <td>
                                  <strong>GST</strong>
                                </td>
                                <td>18% on (brokerage + transaction charges)</td>
                                <td>18% on (brokerage + transaction charges)</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>SEBI charges</strong>
                                </td>
                                <td>Agri – ₹1 / crore</td>
                                <td>₹10 / crore</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>Non-agri – ₹10 / crore</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Stamp charges</strong>
                                </td>
                                <td>0.002% or ₹200 / crore on buy side</td>
                                <td>0.003% or ₹300 / crore on buy side</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            </tbody>
                          </Table>
                        </Tab>
                      </Tabs>
                    </div>
                  </Tab>
                </Tabs>}
                <div className="text-center mt-5">
                  <span className={"chargesexplain_btn charges_showmore" + " " + dmore} id="more" onClick={clickHandler}>Show More</span>
                  <span className={"chargesexplain_btn charges_lessmore" + " " + dless} id="less" onClick={clickHandler}>Show Less</span>
                </div>
                <div className={"chargesexplainedfull_section" + " " + dless}>
                  <div className="each-section margin-top">
                    <h4>Charges Explained</h4>
                    <h3>Securities/Commodities transaction tax</h3>
                    <p>
                      Tax by the government when transacting on the exchanges. Charged as above on both buy and sell sides when trading equity delivery. Charged only on selling side when trading intraday or on F&O.

                    </p>
                    <p>
                      STT/CTT can be a lot more than the brokerage we charge. Important to keep a tab.
                    </p>
                  </div>
                  <div className="each-section">
                    <h3>Transaction/Turnover Charges</h3>
                    <p>
                      Charged by exchanges (NSE, BSE, MCX) on the value of your transactions.
                    </p>
                    <p>
                      BSE has revised transaction charges in XC, XD, XT, Z and ZP groups to Rs.10,000 per crore w.e.f 01.01.2016. (XC and XD groups have been merged into a new group X w.e.f 01.12.2017)
                    </p>
                    <p>
                      BSE has revised transaction charges in SS and ST groups to Rs.1,00,000 per crore of gross turnover.
                    </p>
                  </div>
                  <div className="each-section">
                    <h3>Call & trade</h3>
                    <p>
                      Additional charges of ₹50 per order for orders placed through our support/dealing desk.
                    </p>
                  </div>
                  <div className="each-section">
                    <h3>Stamp charges</h3>
                    <p>
                      Stamp charges by the Government of India as per the Indian Stamp Act of 1899 for transacting in instruments on the stock exchanges and depositories.
                    </p>
                  </div>
                  <div className="each-section">
                    <h3>NRI brokerage charges</h3>
                    <p>₹100 per order for futures and options.</p>
                    <p>
                      For a non-PIS account, 0.5% or ₹100 per executed order for equity (whichever is lower).
                    </p>
                    <p>
                      For a PIS account, 0.5% or ₹200 per executed order for equity (whichever is lower).
                    </p>
                    <p>
                      ₹500 + GST as yearly account maintenance charges (AMC) charges.
                    </p>
                  </div>
                  <div className="each-section">
                    <h3>GST</h3>
                    <p>
                      Tax levied by the government on the services rendered. 18% of ( brokerage + transaction charges)
                    </p>
                  </div>
                  <div className="each-section">
                    <h3>SEBI Charges</h3>
                    <p>
                      Charged at ₹10 per crore by Securities and Exchange Board of India for regulating the markets.
                    </p>
                  </div>
                  <div className="each-section">
                    <h3>DP (Depository participant) charges</h3>
                    <p>
                      ₹ 13/- per ISI <br></br>
                      *  (*NSDL , CDSL Charges shall be charged additionally as actual)
                    </p>
                  </div>
                  <div className="each-section">
                    <h3>Pledging charges</h3>
                    <p>₹30 + GST per pledge request.</p>
                  </div>
                  <div className="each-section">
                    <h3>AMC (Account maintenance charges)</h3>
                    <p>₹300/year + GST (Free for First year) </p>
                  </div>
                  <div className="each-section">
                    <h3>Corporate action order charges</h3>
                    <p>
                      ₹20 plus GST will be charged for OFS / buyback / takeover / delisting orders placed through Moneysukh Platform.
                    </p>
                  </div>
                  <div className="each-section">
                    <h3>Off-market transfer charges</h3>
                    <p>₹25 or 0.03% of the transfer value (whichever is higher).</p>
                  </div>
                  <div className="each-section">
                    <h3>Physical CMR request</h3>
                    <p>
                      First CMR request is free. ₹20 + ₹100 (courier charge) + 18% GST for subsequent requests.
                    </p>
                  </div>
                  <div className="each-section">
                    <h3>Payment gateway charges</h3>
                    {/* <p>₹9 + GST (Not levied on transfers done via UPI)</p> */}
                    <p>As per the Actual Charges by Payment gateway  (Rs.9+GST for Net Banking transfers and Rs.3+GST for all transfers done via UPI)</p>
                  </div>
                  <div className="each-section">
                    <h3>Delayed payment charges</h3>
                    <h3>A. Negative balance in your account –</h3>
                    <p>
                      0.05% per day or 18% p.a will be charged as interest on the debit balance
                    </p>
                  </div>
                  <div className="each-section">
                    <h3>
                      B. Over-utilisation of non-cash equivalent collateral margin –
                    </h3>
                    <p>
                      Exchanges stipulate that for overnight F&O positions, 50% of the margin needs to compulsorily come in cash or cash equivalent collateral, and the remaining 50% can be in terms of non-cash collateral margin .
                    </p>
                    <p>
                      If you don’t have sufficient cash margin and the shortfall is funded by non-cash collateral, there will be a delayed payment charge of 0.035% per day or 12.5% p.a on the shortfall in the cash margin requirement.
                    </p>
                  </div>
                  <div className="each-section">
                    <h3>Charges for account opening</h3>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>Type of account</td>
                          <td>Equity (for trades on Equity, F&O and Currency)</td>
                          <td>Equity (for trades on Equity, F&O and Currency) and Commodity (MCX)</td>

                        </tr>
                        <tr>
                          <td>
                            Online account
                          </td>
                          <td>
                            ₹ 0.00
                          </td>
                          <td>
                            ₹ 0.00
                          </td>

                        </tr>
                        <tr>
                          <td>
                            Offline account
                          </td>
                          <td>₹ 400</td>
                          <td>₹ 600</td>

                        </tr>
                        <tr>
                          <td>
                            NRI account (offline only)
                          </td>
                          <td>₹ 500</td>
                          <td>N/A</td>

                        </tr>

                        <tr>
                          <td>
                            Partnership, LLP, HUF, or Corporate accounts (offline only)
                          </td>
                          <td>₹ 500</td>
                          <td>₹ 800</td>

                        </tr>

                      </tbody>
                    </Table>

                  </div>

                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default PlanChange;
